(() => {
    class Menu {
        constructor() {
            this.container        = document.querySelector('.navigation');
            this.menu             = document.querySelector('nav.js-main-nav:not(.missing-navigation)');
            this.trigger          = document.querySelector('.js-toggle-menu');
            this.close            = document.querySelector('.js-close-menu');
            this.searchTrigger    = document.querySelector('.js-search-trigger');
            this.isMenuShown      = false; /* this variable saves if the menu has been shown or not */
            this.breakpoint       = App.Interface.Breakpoint.getWidth('sm');
            this.navigation       = document.querySelector(App.Components.selector('navigation'));

            if (this.container) {
                /* Bind Action */
                if (this.menu) {
                    this.bind();
                    this.bindMobileMenuToggle();
                    this.bindMobileSubmenuToggle();
                    this.bindLinkAction();
                    this.update();
                }
            }
        }

        /* shows mobile menu */
        show() {
            App.Layout.normalize();
            this.container.classList.add('js-slide-in');
            const current = this.menu.querySelector('.current');

            if (current) {
                const parents = App.Interface.Utilities.parentsUntil(current, null, '.overflow-container:not(.selected)');

                parents.forEach(element => {
                    element.classList.add('selected');
                    element.parentElement.querySelector('a').classList.add('toggled');
                });
            }

            if (this.trigger) this.trigger.classList.add('active');
            this.isMenuShown = true;
            if (this.searchTrigger) {
                this.searchTrigger.Instance.Toggle.active = false;
            }
            this.hideNavigation();
            App.Layout.Header.showLogo(false);
            App.Layout.Header.allowHiding(false);
            App.Layout.fullOverlay();
            this.reset();
            const loyalSysIframe = document.querySelector('#loyalSysIframe');
            if (loyalSysIframe) {
                loyalSysIframe.classList.add('hidden');
            }
        }

        /* hides mobile menu */
        hide() {
            this.reset();
            this.container.classList.remove('js-slide-in');

            if (this.trigger) this.trigger.classList.remove('active');
            this.isMenuShown = false;
            App.Layout.Header.allowHiding(true);
            App.Layout.fullOverlay(false);
            if (!App.Interface.Utilities.isMobile('all')) {
                this.clearSelected();
            }
            const loyalSysIframe = document.querySelector('#loyalSysIframe');
            if (loyalSysIframe) {
                loyalSysIframe.classList.remove('hidden');
            }

            this.menu.querySelectorAll('ul[level="4"]').forEach(element => {
                if (!element.parentElement.classList.contains('active')) {
                    element.classList.remove('selected');
                }
            });

            this.menu.querySelectorAll('ul[level="3"]').forEach(element => {
                if (!element.parentElement.classList.contains('active')) {
                    element.classList.remove('selected');
                }
            });
        };

        reset() {
            // if there has been nothing to activate
            if (!this.activate(window.location.pathname)) {
                // and if we have a brand defined
                if (App.Brand?.identifier) {
                    this.selectMenuItem(this.container.querySelectorAll('li.' + App.Brand.identifier + ' > a'));
                } else {
                    // Mobile we need to force a brand to show the least items
                    if (App.Interface.Utilities.isMobile('all') && this.isMenuShown) {
                        this.selectMenuItem(this.container.querySelectorAll('li.' + App.Brand.default + ' > a'));
                    } else if (!window.location.pathname.startsWith('/account')) {
                        this.clearSelected();
                    }
                }
            }
        }

        bind() {
            const menuItems = this.menu.querySelectorAll('li.submenu > a');

            if (menuItems) {
                menuItems.forEach(item => {
                    item.addEventListener('click', () => {
                        if (App.Interface.Utilities.isMobile('all') && this.isMenuShown) {
                            event.preventDefault();
                            const parent = item.parentElement;

                            if (parent.classList.contains('selected')) {
                                if (parent.classList.contains('is-top-level')) {
                                    window.location = item.getAttribute('href');
                                }
                            } else {
                                this.selectMenuItem(item);
                            }
                        }
                    });
                });
            }

            window.addEventListener('resize', () => {
                this.reset();
            });

            App.Layout.onNormalize(() => this.hide());
            return this;
        }

        bindMobileMenuToggle() {
            if (this.trigger) {
                this.trigger.addEventListener('click', () => {
                    this.mobileMenuToggle();
                });
            }

            if (this.close) {
                this.close.addEventListener('click', () => {
                    this.mobileMenuToggle();
                });
            }
        }

        mobileMenuToggle() {
            if (this.isMenuShown === false) {
                this.show();
            } else {
                this.hide();
            }
        }

        clearSelected() {
            const selectedItems = this.menu.querySelectorAll('li.selected');

            if (selectedItems) {
                selectedItems.forEach(item => {
                    item.classList.remove('selected');
                });
            }
        }

        toggleNavigation(event = false) {
            if (App.Interface.Utilities.isMobile('all')) {
                if (this.navigation && (typeof this.navigation.getComponent === "function")) {
                    if (this.navigation.getComponent()) {
                        if (event &&
                            !(window.getComputedStyle(this.navigation).visibility === 'visible' &&
                            window.getComputedStyle(this.navigation).display === 'block' &&
                            !this.navigation.classList.contains('active'))
                        ) {
                            event.preventDefault();
                        }

                        this.navigation.getComponent().toggleNavigation();
                    }
                }
            }
        }

        hideNavigation(event = false) {
            if (this.navigation) {
                if (event) {
                    event.preventDefault();
                }

                if (typeof this.navigation.getComponent === "function" && this.navigation.getComponent()) {
                    this.navigation.getComponent().hide();
                }
            }
        }

        bindMobileSubmenuToggle() {
            /* display mobile submenus adding and removing the class selected */
            const toggleNavSub = this.menu.querySelectorAll('.js-toggle-nav-sub');
            const toggleNavSubSub = this.menu.querySelectorAll('.submenu > a:not(.js-toggle-nav-sub)');

            if (toggleNavSub) {
                toggleNavSub.forEach(navSub => {
                    navSub.addEventListener('click', (event) => {
                        event.preventDefault();
                        const parent = event.target.closest('li');
                        const list = parent.querySelector('ul');

                        if (list) {
                            list.classList.toggle('selected');

                            if (event.target.tagName === 'IMG') {
                                event.target.closest('a').classList.toggle('toggled');
                            } else {
                                event.target.classList.toggle('toggled');
                            }
                        }
                    });
                });
            }

            if (toggleNavSubSub) {
                toggleNavSubSub.forEach(navSubSub => {
                    navSubSub.addEventListener('click', (event) => {
                        const parent = event.target.closest('li');
                        const list = parent.querySelector('ul');

                        if (list) {
                            list.classList.toggle('selected');

                            if (event.target.tagName === 'IMG') {
                                event.target.closest('a').classList.toggle('toggled');
                            } else {
                                event.target.classList.toggle('toggled');
                            }
                        }
                    });
                });
            }
        }

        bindLinkAction() {
            /* Menu item click sets class active to its li parent and its parents */
            const ajax = this.menu.querySelectorAll('a.ajax');

            if (ajax) {
                ajax.forEach(item => {
                    item.addEventListener('click', () => {
                        this.activateMenuItem(item);
                    });
                });
            }
        }

        activate(url) {
            const element = this.look(url);

            if (element) {
                this.activateMenuItem(element);
                this.selectMenuItem(element);
                return true;
            }

            return false;
        }

        look(url) {
            if (url) {
                const separator = '/' + App.language;

                if (url === separator) {
                    const element = this.menu.querySelectorAll('a[href="' + separator + '"]');
                    if (element.length) return element;
                } else {
                    let parts = url.split(separator);
                    parts = parts.filter(part => part !== '');

                    if (parts.length > 0) {
                        const element = this.menu.querySelectorAll('a[href="' + separator + parts.join(separator) + '"]');

                        if (element.length) {
                            return element;
                        } else {
                            return this.look(parts.splice(0, parts.length -1).join(separator));
                        }
                    }
                }
            }
        }

        selectMenuItem(element) {
            if (!App.Interface.Utilities.isMobile('all')) this.activateMenuItem(element);

            this.clearSelected();

            if (!App.Interface.Utilities.isMobile('all')) {
                const parents = App.Interface.Utilities.parentsUntil(element, '.js-main-nav:not(.missing-navigation)', 'li');

                if (parents) {
                    parents.forEach(item => {
                        item.classList.add('selected');
                    });

                    parents[0].classList.add('current');
                }
            }
        }

        activateMenuItem(element) {
            const activeItems = this.menu.querySelectorAll('.active');

            if (activeItems) {
                activeItems.forEach(item => {
                    item.classList.remove('active');
                });
            }

            const parents = App.Interface.Utilities.parentsUntil(element, '.js-main-nav', 'li');

            if (parents) {
                parents.forEach(item => {
                    item.classList.add('active');
                });

                parents[0].classList.add('current');
            }
        }

        bindMenuPointerAction() {
            this.MenuPointer.run();
            this.MenuPointer.reset();
        }

        bindSubMenuPointerAction() {
            this.SubMenuPointer.run();
            this.SubMenuPointer.reset();
        }

        update() {
            // In case no item is selected, select at least the brand
            if (this.menu.querySelectorAll('li.active').length === 0) this.reset();
        }

        get menuElement() {
            if (!this._menuElement) {
              this._menuElement = this.menu.querySelector('ul');
            }

            return this._menuElement;
        }
    }
    App.Menu = new Menu();
})();
